import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "join-wrapper" }

import { useJoinTeamDialog } from '@/hooks/useJoinTeamDialog'


export default /*#__PURE__*/_defineComponent({
  __name: 'teamJoin',
  setup(__props) {

const showApplyJoinDialog = useJoinTeamDialog()
const join = () => {
  showApplyJoinDialog()
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_button, {
      class: "join-btn",
      type: "primary",
      onClick: join
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('components.teamHead.joinTeamBtn')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})